import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { DecryptPipe } from '../../../../app/auth/_services/encrypt-decrypt.pipe';

@Component({
  selector: 'app-expense-bifurcation',
  templateUrl: './expense-bifurcation.component.html',
  styleUrls: ['./expense-bifurcation.component.scss']
})
export class ExpenseBifurcationComponent implements OnInit {

  @Output() onCloseEvent = new EventEmitter<any>();
  @Input() ExpenseBifurcation: any;
  TenantId: any;
  CompanyId: any;
  userId: any;

  isMobileView: any;

  constructor(
    private decryptpipe: DecryptPipe,
    private cookieService: CookieService,
  ) { }

  ngOnInit() {
    const ChnageCompnayId = JSON.parse(localStorage.getItem("ChnageCompnayId"));
    this.CompanyId = ChnageCompnayId && ChnageCompnayId.Id;
    this.userId = this.decryptpipe.transform(JSON.parse(this.cookieService.get("UserId")));
    this.TenantId = JSON.parse(localStorage.getItem("ChnageCompnayId")).TenantId;
  }

  close() {
    this.onCloseEvent.emit();
  }

}
